import { useColors } from "../../../../hooks/colors/useColors";
import { Container } from "../../../UI/container/Container";
import { Grid, Text, Paper } from "@mantine/core";
import { SpecialistCard } from "./SpecialistCard";
import {
  SpecialistData,
  useSpecialistList,
} from "../../../../hooks/react-query/useSpecialistList";
import { useTranslation } from "next-i18next";
import { Fragment } from "react";
import { IconAlertCircle } from "@tabler/icons";

export function Specialists() {
  const { colors } = useColors();
  const { specialists } = useSpecialistList();
  const { t } = useTranslation("common");

  const specialistKeys = specialists ? Object.keys(specialists) : [];
  const firstSpecialistKey = specialistKeys[0];
  const specialist: SpecialistData | undefined =
    firstSpecialistKey && specialists
      ? specialists[firstSpecialistKey]
      : undefined;

  return (
    <>
      <Container noHeight>
        <Grid className="items-center">
          {specialist && (
            <Fragment>
              <Grid.Col
                span={{ base: 12, md: 6, lg: 5 }}
                className="flex justify-center"
              >
                <SpecialistCard specialist={specialist} />
              </Grid.Col>

              <Grid.Col
                span={{ base: 12, md: 6, lg: 7 }}
                className="flex justify-center"
              >
                <Paper
                  shadow="sm"
                  p="xl"
                  radius="md"
                  withBorder
                  style={{
                    backgroundColor: colors.background,
                    borderColor: colors.primary,
                  }}
                  className="w-full flex flex-col gap-4"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <IconAlertCircle color={colors.primary} size={48} />
                    <Text size="2rem" fw={900} className="tracking-wide">
                      COMUNICADO
                    </Text>
                  </div>
                  <p>
                    <Text size="lg" className="text-gray-600 leading-normal">
                      Por <b>motivos de força maior</b>, a Psiworks irá proceder
                      a uma reorganização da sua atividade clínica.
                    </Text>
                  </p>
                  <p>
                    <Text size="lg" className="leading-relaxed">
                      <b>
                        O Dr. João Parente continuará a assegurar pessoalmente
                        as consultas de Psiquiatria e Psicoterapia
                      </b>
                      , mantendo o acompanhamento dos seus atuais pacientes e a
                      possibilidade de admissão de novos pacientes.
                    </Text>
                  </p>
                  <p>
                    <Text size="lg" className="text-gray-600 leading-normal">
                      As{" "}
                      <b>
                        primeiras consultas poderão ser realizadas por
                        videoconferência ou presencialmente
                      </b>
                      , de acordo com a preferência do paciente e a
                      disponibilidade de vagas.
                    </Text>
                  </p>
                  <p>
                    <Text size="lg" className="text-gray-600 leading-normal">
                      Nas consultas subsequentes,{" "}
                      <b>
                        dar-se-á sempre preferência ao acompanhamento por
                        videoconferência
                      </b>
                      , podendo algumas consultas, em casos selecionados e
                      mediante avaliação prévia, ser realizadas presencialmente.
                    </Text>
                  </p>
                  <div className="pt-2 border-t border-gray-200">
                    <p>
                      <Text size="lg" fw={500}>
                        Para marcação de consultas ou outros esclarecimentos,
                        deverão ser utilizados os seguintes contactos:
                      </Text>
                    </p>
                    <Text size="lg" className="mt-1">
                      <b>Telefone/WhatsApp:</b> 928 332 634
                      <br />
                      <b>E-mail:</b>{" "}
                      <a
                        href="mailto:geral@psiworks.pt"
                        className="underline hover:opacity-80"
                        style={{ color: colors.primary }}
                      >
                        geral@psiworks.pt
                      </a>
                    </Text>
                  </div>

                  <Text size="lg" className="text-gray-600 leading-normal">
                    <p>
                      A Psiworks continuará igualmente ativa, fora do âmbito da
                      prestação regular de cuidados clínicos por outros
                      profissionais, para o desenvolvimento de{" "}
                      <b>
                        projetos selecionados de Formação Profissional e de
                        Produção de Software na área da Saúde.
                      </b>
                    </p>
                  </Text>

                  <Text size="lg" className="text-gray-600 leading-normal">
                    Agradecemos profundamente a confiança que pacientes,
                    profissionais e parceiros têm depositado na Psiworks ao
                    longo dos anos.
                  </Text>
                  <br></br>
                  <p>
                    <Text size="lg" className="text-gray-500 italic mt-2">
                      <b>Psiworks – Cuidados de Saúde, Lda.</b>
                    </Text>
                  </p>
                </Paper>
              </Grid.Col>
            </Fragment>
          )}
        </Grid>
      </Container>
    </>
  );
}
